import { onFetchUsers } from 'redux/ums-user-management/sagas/fetchUsers';
import { onFetchRoles, onFetchSingleRole } from 'redux/ums-user-management/sagas/fetchRoles';
import { onSaveRole, onEditRole } from 'redux/ums-user-management/sagas/saveRole';
import { onDeleteRole } from 'redux/ums-user-management/sagas/deleteRole';
import { onFetchfetchPrivileges } from 'redux/ums-user-management/sagas/fetchPrivileges';
import { onFetchfetchStatistics } from 'redux/ums-user-management/sagas/fetchStatistics';
import { call, all } from 'redux-saga/effects';

export default function* formsSaga() {
  yield all([
    call(onFetchUsers),
    call(onFetchRoles),
    call(onFetchSingleRole),
    call(onSaveRole),
    call(onEditRole),
    call(onDeleteRole),
    call(onFetchfetchPrivileges),
    call(onFetchfetchStatistics),
  ]);
}
